import React, { useState } from 'react';
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Stack,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { MultiStepForm, Step } from 'react-multi-form-custom-fix';
import BasicDetails from '../shared/basic-details';
import AboutUs from '../shared/about-us';
import AboutService from '../shared/about-service';
import ContactUs from '../shared/contact-us';
import SocialLinks from '../shared/social-links';
import Gallery from '../shared/gallery';
import HeroSection from '../shared/hero-section';

function AddSite() {
  const [step, setStep] = useState(1);

  const nextClicked = () => {
    setStep(step + 1);
  };

  const prevClicked = () => {
    setStep(step - 1);
  };

  return (
    <>
      <Breadcrumb marginTop={2} marginLeft={2}>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="/">
            Home
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="/sites">
            Sites
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="/sites/add">
            Add
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>
      <Stack mt={4} direction={{ base: 'column', lg: 'row' }}>
        <Box w={'100%'}>
          <MultiStepForm activeStep={step}>
            <Step label="Basic Details">
              <BasicDetails nextClicked={nextClicked} />
            </Step>
            <Step label="Hero Section">
              <HeroSection
                isEdit
                prevClicked={prevClicked}
                nextClicked={nextClicked}
              />
            </Step>
            <Step label="About Us">
              <AboutUs prevClicked={prevClicked} nextClicked={nextClicked} />
            </Step>
            <Step label="About Service">
              <AboutService
                prevClicked={prevClicked}
                nextClicked={nextClicked}
              />
            </Step>
            <Step label="Gallery">
              <Gallery prevClicked={prevClicked} nextClicked={nextClicked} />
            </Step>
            <Step label="Contact Us">
              <ContactUs prevClicked={prevClicked} nextClicked={nextClicked} />
            </Step>
            <Step label="Social Links">
              <SocialLinks
                prevClicked={prevClicked}
                nextClicked={nextClicked}
              />
            </Step>
          </MultiStepForm>
        </Box>
      </Stack>
    </>
  );
}

export default AddSite;
